import { LockOutlined } from "@ant-design/icons";
import { Button, Form, Space } from "antd";
import React, { useState } from "react";
import { useGoogleReCaptcha } from "react-google-recaptcha-v3";
import { useHistory, useLocation } from "react-router-dom";
import { AdminService } from "../../services/AdminService";
const LoginForm = () => {
  const { executeRecaptcha } = useGoogleReCaptcha();
  const [bloading, setBloading] = useState(false);
  const router = useHistory();
  const location = useLocation();
  const { from } = location.state || { from: { pathname: "/" } };
  const onFinish = async (values) => {
    setBloading(true);
    // reCAPTCHA v3 token'i. Alinamazsa (betik yuklenmedi, eklenti vb.) bos gonderilir;
    // dogrulamayi zorlayip zorlamamak sunucudaki "Captcha:Enabled" ayarina baglidir.
    let ctoken = null;
    try {
      if (executeRecaptcha) ctoken = await executeRecaptcha("login_page");
    } catch (e) {
      ctoken = null;
    }
    AdminService.checkLogin({ ...values, ctoken })
      .then((data) => {
        localStorage.setItem("token", data.data.token);
        localStorage.setItem("user", JSON.stringify(data.data.user));
        from.pathname === "/" ? router.push("/admin") : router.replace(from);
      })
      .catch(() => {
        // Hata bildirimini HttpClient interceptor'u zaten gosteriyor.
      })
      .finally(() => {
        setBloading(false);
      });
  };
  return (
    <div
      className=" rounded-3xl border border-gray-300 flex items-center justify-center bg-white py-8 px-4  sm:px-6 lg:px-8 shadow-xl"
      style={{ minWidth: "320px", maxWidth: "95%" }}
    >
      <div className="max-w-md w-full space-y-8">
        <div>
          <img
            className="mx-auto h-16 w-auto"
            src={require("../../assets/images/logo.svg").default}
            alt="Logo"
          />
          <h2 className="mt-6 text-center text-xl font-extrabold text-yellow-600">
            Please Sign in
          </h2>
        </div>
        <Form className="mt-8 space-y-2" onFinish={onFinish}>
          <Form.Item name="email">
            <div>
              <input
                id="email-address"
                name="email"
                required
                className="appearance-none rounded-none relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-t-md focus:outline-none focus:ring-yellow-500 focus:border-yellow-500 focus:z-10 sm:text-sm"
                placeholder="Username"
              />
            </div>
          </Form.Item>
          <Form.Item name="password">
            <div className="-mt-10">
              <label htmlFor="password" className="sr-only">
                Password
              </label>
              <input
                id="password"
                name="password"
                type="password"
                autoComplete="current-password"
                required
                className="appearance-none rounded-none relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-b-md focus:outline-none focus:ring-yellow-500 focus:border-yellow-500 focus:z-10 sm:text-sm"
                placeholder="Password"
              />
            </div>
          </Form.Item>

          <Space className="w-full" direction="vertical">
            <Button
              loading={bloading}
              htmlType="submit"
              type="primary"
              block
              icon={<LockOutlined />}
            >
              Sign in
            </Button>
          </Space>
        </Form>
      </div>
    </div>
  );
};

export default LoginForm;
